import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-check-circle-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './check-circle-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class CheckCircleIconComponent {
  @Input() checked = false;
}
